import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Link } from '@p81-common/ui';
import { useTranslation } from 'react-i18next';

import { Button, Icon, Text } from 'components/common/Elements/Elements';
import TrueFalse from '../TrueFalse/TrueFalse';
import { Typography } from '@p81-common/ui';

import { textToDate } from 'utils/common';

import classes from './DropList.module.scss';
import useStyles from './styles';

const DropList = ({
  title,
  value,
  subtable,
  isActButtonVisible,
  onChange,
  topActionTitle,
  topActionOnClick
}) => {
  const { t } = useTranslation(['activity']);
  const [listOpen, setListOpen] = useState();
  const styles = useStyles();
  return (
    <div className={classes.wrap}>
      <Button
        className={cn(classes.title, classes.title_btn)}
        onClick={() => {
          setListOpen(!listOpen);
        }}
        aria-label="Open/close"
      >
        <div className={classes.title}>
          <div
            className={cn(
              classes.indicatorBtn,
              listOpen && classes.indicatorBtn_open
            )}
          >
            <Icon
              size="16px"
              icon="arrow"
              className={
                listOpen !== undefined
                  ? listOpen
                    ? classes.icon_down
                    : classes.icon_up
                  : classes.icon_default
              }
            />
          </div>
          <Text size={4}>{title}</Text>
        </div>
        {isActButtonVisible && onChange && (
          <Text size={4} className={classes.featureSwitch}>
            <Link table href="#" onClick={onChange}>
              {value ? 'Turn Off' : 'Turn On'}
            </Link>
          </Text>
        )}
        {topActionTitle && topActionOnClick && (
          <Typography
            onClick={e => {
              e.stopPropagation();
              topActionOnClick();
            }}
            className={styles.itemButton}
          >
            {topActionTitle}
          </Typography>
        )}
        <div className={classes.status}>
          {value !== undefined ? (
            <TrueFalse value={value} />
          ) : (
            <div className={classes.status_hiden} />
          )}
        </div>
      </Button>
      {listOpen && (
        <ul>
          {subtable.map(item => (
            <li
              className={cn(
                classes.item,
                listOpen && classes.item_open,
                item.hideNext && classes.item_hideNext
              )}
              key={item.title}
            >
              {item.title === t('activity:platform.WEB_FILTERING_RULES') ||
              (item.title === t('activity:platform.BYPASS_RULES') &&
                item.value &&
                item.link) ? (
                item.value && item.link ? (
                  <Link to={item.link}>
                    <Text size={4}>{item.title}</Text>
                    <div className={classes.featureUsageGreenDot} />
                    <Text size={4} className={classes.webFilteringUsageDate}>
                      {textToDate(item.date)}
                    </Text>
                  </Link>
                ) : (
                  <Text size={4}>{item.title}</Text>
                )
              ) : item.value && item.link ? (
                item.title === 'None' &&
                item.hide ===
                  true(
                    <Link to={item.link}>
                      <Text size={4}>{item.title}</Text>
                    </Link>
                  )
              ) : (
                <Text size={4}>{item.title}</Text>
              )}
              {item.isActButtonVisible && item.onClick && item.buttonTitle && (
                <Typography
                  onClick={item.onClick}
                  className={styles.itemButton}
                >
                  {item.buttonTitle}
                </Typography>
              )}
              {typeof item.value == 'boolean' ? (
                <TrueFalse value={item.value} />
              ) : (
                <Text className={classes.iconWrap}>
                  {item.value ? item.value : <TrueFalse value={item.value} />}
                </Text>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

DropList.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.bool,
  subtable: PropTypes.array.isRequired,
  isActButtonVisible: PropTypes.bool,
  onChange: PropTypes.func,
  topActionTitle: PropTypes.string,
  topActionOnClick: PropTypes.func
};

export default DropList;
